// extracted by mini-css-extract-plugin
export default {"side":"index_side__kUxPB","logo":"index_logo__038c9","menus":"index_menus__vhYPT","divider":"index_divider__NNyG+"};